import { useState } from "react";

let visitCounter = 0;

/**
 * A key identifying one VISIT: this mount's continuous engagement with
 * `identity`. Stable across re-renders while `identity` is unchanged; a new
 * key when `identity` changes AND on every fresh mount — so per-visit UI
 * state (scroll offsets, list snapshots) keyed by it can never leak into a
 * later visit, even when the user returns to the same identity.
 *
 * The identity change is applied during render (the adjust-state-on-render
 * pattern), so the new key is in effect in the same committed render the
 * identity changes in — no stale-key frame for children to record under.
 */
export function useVisitId(identity: string): string {
  const [visit, setVisit] = useState(() => ({
    identity,
    nonce: ++visitCounter,
  }));
  if (visit.identity !== identity) {
    setVisit({ identity, nonce: ++visitCounter });
  }
  return `${visit.identity}@v${visit.nonce}`;
}
